import axios from './axios-instance';

export function fetchPage() {
  return axios.get('/unioncenter/web-background/role-function/query-all-role');
}

export function fetchList() {
  return axios.get('/unioncenter/web-background/role-function/query-all-role');
}

export function fetchDetail(params) {
  return axios.get('/unioncenter/web-background/role-function/get-role-functions', { params });
}

export function fetchFuncList() {
  return axios.get('/unioncenter/web-background/role-function/get-user-functions-v2');
}

export function add(payload) {
  return axios.post('/unioncenter/web-background/role-function/add-role', payload);
}

export function edit(payload = {}) {
  return axios.post('/unioncenter/web-background/role-function/upd-role', payload);
}

export function updateStatus(payload) {
  return axios.post('/unioncenter/role/updateStatus', payload);
}

export function del(params) {
  return axios.get('/unioncenter/web-background/role-function/del-role', { params });
}

export function delCheck(payload = {}) {
  return axios.post('/unioncenter/role/deleteCheck', payload);
}
